import { type AdminUserSelectDto, UserProfileRole, UserStatus } from '@@types/api.types';
import { createColumnConfigHelper } from '@components/data-table-filter/core/filters';
import { BadgeCheckIcon, CalendarClockIcon, ShieldAlertIcon, UserCircleIcon } from 'lucide-react';

const dtf = createColumnConfigHelper<AdminUserSelectDto>();

export const columnsConfig = [
  dtf
    .option()
    .id('role')
    .accessor((row) => {
      const role = row.profile?.role;
      return role ?? 'NONE';
    })
    .displayName('Role')
    .icon(UserCircleIcon)
    .options([
      { label: 'Admin', value: UserProfileRole.ADMIN },
      { label: 'Expert', value: UserProfileRole.EXPERT },
      { label: 'Intelligence', value: UserProfileRole.INTELLIGENCE },
      { label: 'Innovator', value: UserProfileRole.INNOVATOR },
      { label: 'No Role', value: 'NONE' },
    ])
    .build(),
  dtf
    .option()
    .id('status')
    .accessor((row) => row.status)
    .displayName('Status')
    .icon(ShieldAlertIcon)
    .options([
      { label: 'Approved', value: UserStatus.APPROVED },
      { label: 'Pending', value: UserStatus.PENDING },
      { label: 'Blocked', value: UserStatus.BLOCKED },
    ])
    .build(),
  dtf
    .option()
    .id('emailVerified')
    .accessor((row) => (row.emailVerified ? 'true' : 'false'))
    .displayName('Email Verified')
    .icon(BadgeCheckIcon)
    .options([
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ])
    .build(),
  dtf
    .option()
    .id('expired')
    .accessor((row) => {
      if (!row.accessExpiredAt) return 'false';
      const expiredDate = new Date(String(row.accessExpiredAt));
      const isExpired = expiredDate <= new Date();
      return isExpired ? 'true' : 'false';
    })
    .displayName('Access Expired')
    .icon(CalendarClockIcon)
    .options([
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ])
    .build(),
] as const;
